export default {
  'paymentHistory.columnDate': 'Date / Period',
  'paymentHistory.paymentHistoryFaqPayments': 'Payment FAQ',
  'paymentHistory.noHistory': "There's no payment history",
};
